import { Card, Checkbox, Space, Typography } from 'antd';
import ProfileAwardRow from '../../../profiles/components/ProfileAwardRow';
import ImportTitle from './ImportTitle';

const { Text, Paragraph } = Typography;

const ImportAwardsCertificationsStep = ({ accountData, selectedFields, onFieldSelection }) => {
    const CheckboxField = ({ checked, onChange, children, style = {} }) => (
        <div className="flex items-start gap-4 flex-row" style={{ ...style }}>
            <Space>
                <Checkbox checked={checked} onChange={onChange} />
            </Space>
            <div style={{ flex: 1 }}>{children}</div>
        </div>
    );

    const formatDate = (dateString) => {
        if (!dateString) return 'Present';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short'
        });
    };

    return (
        <div className="py-6">
            <ImportTitle
                title="Awards & Certifications"
                description="Select the awards and certifications you'd like to import to your profile"
            />

            <Space direction="vertical" size={24} style={{ width: '100%' }}>
                {/* Awards */}
                {accountData?.awards?.length > 0 && (
                    <Card title={
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                                <i className="fas fa-trophy" />
                                <span>Awards ({accountData?.awards?.length || 0})</span>
                            </div>
                            <Space>
                                <Checkbox
                                    checked={accountData?.awards?.every((_, idx) => selectedFields?.awards?.[idx])}
                                    onChange={(e) => {
                                        const newValue = {};
                                        accountData?.awards?.forEach((_, idx) => {
                                            newValue[idx] = e.target.checked;
                                        });
                                        onFieldSelection('awards', newValue);
                                    }}
                                >
                                    <span className="text-xs text-gray-500">Select All</span>
                                </Checkbox>
                            </Space>
                        </div>
                    }>
                        <Space direction="vertical" size={32} style={{ width: '100%' }}>
                            {accountData?.awards?.map((award, index) => (
                                <CheckboxField
                                    key={`award-${index}`}
                                    checked={selectedFields?.awards?.[index]}
                                    onChange={(e) => onFieldSelection('awards', {
                                        ...(selectedFields?.awards || {}),
                                        [index]: e.target.checked
                                    })}
                                >
                                    <div className="flex flex-row items-start gap-3 mb-2">
                                        <div className="-my-6">
                                            <ProfileAwardRow award={award} />
                                        </div>
                                    </div>
                                </CheckboxField>
                            ))}
                        </Space>
                    </Card>
                )}

                {/* Certifications */}
                {accountData?.certifications?.length > 0 && (
                    <Card title={
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                                <i className="fas fa-award" />
                                <span>Certifications ({accountData?.certifications?.length || 0})</span>
                            </div>
                            <Space>
                                <Checkbox
                                    checked={accountData?.certifications?.every((_, idx) => selectedFields?.certifications?.[idx])}
                                    onChange={(e) => {
                                        const newValue = {};
                                        accountData?.certifications?.forEach((_, idx) => {
                                            newValue[idx] = e.target.checked;
                                        });
                                        onFieldSelection('certifications', newValue);
                                    }}
                                >
                                    <span className="text-xs text-gray-500">Select All</span>
                                </Checkbox>
                            </Space>
                        </div>
                    }>
                        <Space direction="vertical" size={32} style={{ width: '100%' }}>
                            {accountData?.certifications?.map((cert, index) => (
                                <CheckboxField
                                    key={`cert-${index}`}
                                    checked={selectedFields?.certifications?.[index]}
                                    onChange={(e) => onFieldSelection('certifications', {
                                        ...(selectedFields?.certifications || {}),
                                        [index]: e.target.checked
                                    })}
                                >
                                    <div className="flex flex-row items-start gap-3 mb-2">
                                        <div>
                                            <Text strong>Name: </Text>
                                            <Text>{cert.name}</Text>
                                            {cert.earned_at && (
                                                <>
                                                    <br />
                                                    <Text strong>Earned: </Text>
                                                    <Text>{formatDate(cert.earned_at)}</Text>
                                                </>
                                            )}
                                            <br />
                                            <Text strong>Description: </Text>
                                            <Paragraph style={{ margin: 0 }}>{cert.description || 'N/A'}</Paragraph>
                                        </div>

                                        {cert.image_path && (
                                            <img className="w-full h-auto max-w-20 ml-auto" src={cert.image_path} alt={cert.name} />
                                        )}
                                    </div>
                                </CheckboxField>
                            ))}
                        </Space>
                    </Card>
                )}
            </Space>
        </div>
    );
};

export default ImportAwardsCertificationsStep;
